// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "\n.purchase_session {\n    position: relative;\n}\n.purchase_session ul.nav-tabs {\n    position: absolute;\n    top: -150px;\n    width: 100%;\n    background: transparent;\n}\n.purchase_session ul.nav-tabs li {\n    width: 25%;\n}\n.purchase_session ul.nav-tabs li a {\n    border: none;\n}\n.purchase_session .nav-link.active {\n    border-bottom: 2px solid #fff;\n    background: transparent;\n}\n.purchase_session .nav-link.active .head_register-list {\n    color: #fff;\n}\n", ""]);
// Exports
module.exports = exports;
